import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

const vehicleInfoExcludeNodes = [
  "VIN",
  "vehicleType",
  "make",
  "primaryColor",
  "model",
  "series",
  "bodyStyles",
  "iterationKey",
  "sequenceKey",
  "modelYear",
  "vehicleRegistrants",
  "stockPhotos",
];

export const getOtherDetailsRows = (record, index) => {
  const rows = [];
  _.forEach(Object.keys(record), (key, keyIndex) => {
    if (vehicleInfoExcludeNodes.indexOf(key) === -1) {
      const value = _.get(record, `${key}[0]._`, "");
      if (value !== "") {
        rows.push(
          <Table.Row key={`veh_inf_other_row_${index}_${keyIndex}`}>
            <Table.Cell width={6}>
              {_.get(record, `${key}[0].$.display`)}
            </Table.Cell>
            <Table.Cell width={10}>{value}</Table.Cell>
          </Table.Row>
        );
      }
    }
  });
  return rows;
};

export default getOtherDetailsRows;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/VehicleOtherDetails.js